import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {devConfig, countries, profile, walletsList} from "../../../config/config"; // Importing configuration settings

/**
 * Class representing the FilterJackpotPrizeReportSportBetView.
 * @extends JetView
 */
export default class FilterJackpotPrizeReportSportBetView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service for translations
        const left = {
            id: "a1", // Unique identifier for the left section
            margin: 5,
            rows: [
                {
                    responsive: "a1", // Responsive design identifier
                    margin: 15,
                    css: "on-row", // CSS class for styling
                    cols: [
                        {
                            id: 'Datepicker', // Identifier for the date picker
                            name: "Datepicker",
                            view: "text", // Type of view
                            css: "reportrange", // CSS class for styling
                            value: moment().subtract(0, 'days').format('YYYY-MM-DD') + ' - ' + moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha"), // Label with icon
                            labelPosition: "top", // Position of the label
                            minWidth: 200,
                            placeholder: _("Click para seleccionar "), // Placeholder text
                        },
                        {
                            id: "Date", // Identifier for the date input
                            name: "Date",
                            view: "datepicker", // Type of view
                            stringResult: true, // Return string result for date
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha"), // Label with icon
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: "%d %M %Y", // Date format
                            suggest: {
                                type: "calendar", // Suggestion type
                                body: {
                                    maxDate: new Date() // Maximum date for selection
                                }
                            }
                        },
                        {
                            id: "id", // Identifier for player ID input
                            name: "id",
                            view: "text", // Type of view
                            type: "number", // Input type
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("ID jugador"), // Label with icon
                            labelPosition: "top",
                            placeholder: _("ID jugador"), // Placeholder text
                        },
                        {
                            id: "playerName", // Identifier for player name input
                            name: "playerName",
                            view: "text", // Type of view
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Nombre del Jugador"), // Label with icon
                            labelPosition: "top",
                            placeholder: _("Nombre"), // Placeholder text
                        },
                        {
                            view: "richselect", // Dropdown selection view
                            name: "documentType",
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Tipo Documento"), // Label with icon
                            labelPosition: "top",
                            placeholder: _("Click para seleccionar "), // Placeholder text
                            value: "0", // Default selected value
                            options: [ // Options for document type selection
                                {"id": "C", "value": _("DNI")},
                                {"id": "E", "value": _("Cédula de extranjería")},
                                {"id": "P", "value": _("Pasaporte")}
                            ]
                        },
                    ]
                },
                {
                    responsive: "a1", // Responsive design identifier
                    margin: 15,
                    css: "on-row", // CSS class for styling
                    cols: [
                        {
                            id: "documentNumber", // Identifier for document number input
                            name: "documentNumber",
                            view: "text", // Type of view
                            type: "number", // Input type
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _("Numero del documento"), // Label with icon
                            labelPosition: "top",
                            placeholder: _("Numero"), // Placeholder text
                        },
                        {
                            id: "jackpotId", // Identifier for jackpot ID input
                            name: "jackpotId",
                            view: "text", // Type of view
                            type: "number", // Input type
                            minWidth: 200,
                            label: _("ID Jackpot"), // Label text
                            labelPosition: "top",
                            placeholder: _("ID Jackpot") // Placeholder text
                        },
                        {
                            id: "gameName", // Identifier for game name input
                            name: "gameName",
                            view: "text", // Type of view
                            minWidth: 200,
                            label: _("Nombre del Juego"), // Label text
                            labelPosition: "top",
                            placeholder: _("Nombre del Juego"), // Placeholder text
                        },
                        {}
                    ]
                },
            ]
        };
        const upper_section = {
            css: "father-container", // CSS class for styling
            rows: [{
                margin: 10,
                cols: [
                    left // Left section containing input fields
                ]
            }]
        };
        const buttons = {
            padding: 10,
            cols: [
                {},
                {
                    view: "button", // Button for clearing the form
                    value: _("Limpiar"), // Button text
                    width: (screen == "small") ? 0 : 100, // Conditional width based on screen size
                    minWidth: 200,
                    margin:10,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('Datepicker').setValue(""); // Clear datepicker value
                    }
                },
                {
                    id: "consultDesk", // Identifier for consult button
                    view: "button", // Button for consulting data
                    value: _("Consultar"), // Button text
                    hotkey: "enter", // Hotkey for the button
                    type: "form", // Button type
                    width: (screen == "small") ? 0 : 100, // Conditional width based on screen size
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get values from the form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        console.log(filterdata) // Log filter data for debugging
                        this.app.callEvent("gamesPerformance:filter", [filterdata]); // Call event with filter data
                        $$("b5").collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    }
                }
            ]
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: "button", // Button for clearing the second form
                    value: _("Limpiar"), // Button text
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('Datepicker').setValue(""); // Clear datepicker value
                    }
                },
                {
                    id: "consultDesk", // Identifier for consult button
                    view: "button", // Button for consulting data
                    value: _("Consultar"), // Button text
                    hotkey: "enter", // Hotkey for the button
                    type: "form", // Button type
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from the second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent("gamesPerformance:filter", [filterdata]); // Call event with filter data
                    }
                }
            ]
        };
        const accordion_section2 = {
            type: "wide", // Type of accordion section
            rows: [
                {
                    multi: true, // Allow multiple sections to be open
                    view: "accordion", // Accordion view
                    css: "betShop", // CSS class for styling
                    collapsed: true, // Initial state of the accordion
                    type: "clean", // Clean type for styling
                    rows: [
                        {
                            id: "b5", // Identifier for the filter section
                            header: _("Filtros"), // Header text
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons] // Include upper section and buttons
                            }
                        }
                    ]
                }
            ]
        };
        const accordion_section3 = {
            view: "scrollview", // Scrollable view
            scroll: "xy", // Scroll in both directions
            body: {
                padding: 10,
                rows: [upper_section] // Include upper section
            }
        };
        const filterPopup = webix.ui({ // Create a popup window for filters
            view: "window",
            move: true, // Allow window to be moved
            id: "filterPopup", // Identifier for the popup
            fullscreen: true, // Fullscreen mode
            modal: true, // Modal window
            position: "center", // Center position
            head: {
                view: "toolbar", // Toolbar for the popup header
                cols: [
                    {view: "label", label: _("Filtros"), align: "center"}, // Label for the header
                    {
                        view: "icon", icon: "wxi-close", click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close icon click
                        }
                    }
                ]
            },
            body: {
                view: "form", id: 'myForm2', // Form inside the popup
                type: "clean",
                rows: [
                    accordion_section3, buttons2 // Include accordion section and buttons
                ],
                rules: {
                    "fname": webix.rules.isNotEmpty // Validation rule for the form
                }
            }
        });
        return {
            id: 'myForm', // Identifier for the main form
            view: "form", // Type of view
            type: "clean",
            rows: [
                (screen.width > 500 && screen.height > 500) ? accordion_section2 : {height: 1, width: 0} // Conditional rendering based on screen size
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for the form
            }
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$("Date").hide(); // Hide Date input if typeDate is not 2
                $$("Datepicker").show(); // Show Datepicker
            } else {
                $$("Date").show(); // Show Date input
                $$("Datepicker").hide(); // Hide Datepicker
            }
        });
        const lang = this.app.getService("locale").getLang(); // Get current language
        $$('Datepicker').attachEvent("onAfterRender", function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
